import React, { useEffect, useState } from 'react';
import { Col, Form, FormLabel, Row } from '@themesberg/react-bootstrap';
import CustomForm from '../../../components/CustomForm';
import { postApi } from '../../../redux/api';
import { accountTypes, bankList } from '../../accounts/AccountForm';
import { useParams } from 'react-router-dom';

export default ({ form = {}, setForm = (f) => f, errors = {}, setErrors = (f) => f }) => {

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    
    setForm((p) => ({ ...p, [name]: value }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  return (
    // <>
    //   <h6 className="my-2 text-center">Bank Detail</h6>
    //   <Form>
    //     <CustomForm
    //       handleChange={handleChange}
    //       fields={[
    //         {
    //           label: 'Account Name',
    //           value: form.contractor_acc_name,
    //           name: 'contractor_acc_name',
    //         },
    //         {
    //           label: 'Bank Name',
    //           name: 'contractor_bank_name',
    //           value: form.contractor_bank_name,
    //         },
    //         {
    //           label: 'Account Number',
    //           name: 'contractor_acc_no',
    //           value: form.contractor_acc_no,
    //         },
    //         {
    //           label: 'Sort code',
    //           value: form.sort_code,
    //           name: 'sort_code',
    //         },
    //       ]}
    //     />
    //   </Form>
    // </>
    <Row>
          <h6 className="my-2 text-center">Bank Details</h6>
          <Col md={12}>
            <CustomForm
              handleChange={handleChange}
              fields={[
                {
                  label: "Account Name",
                  name: "contractor_acc_name",
                  value: form.contractor_acc_name,
                  required: true,
                  error: errors.contractor_acc_name,
                },
                {
                  label: "Bank Name",
                  type: "custom",
                  component: () => (
                    <>
                      <FormLabel>
                        Bank Name
                        <span className="text-danger ms-1">*</span>
                      </FormLabel>
                      <select
                        onChange={({ target: { value } }) => {
                          setForm((p) => ({
                            ...p,
                            contractor_bank_name: value,
                          }));
                          // Clear error when user selects
                          if (errors.contractor_bank_name) {
                            setErrors(prev => ({ ...prev, contractor_bank_name: null }));
                          }
                        }}
                        value={form.contractor_bank_name}
                        name="contractor_bank_name"
                        className={`form-control form-control-sm ${errors.contractor_bank_name ? 'is-invalid' : ''}`}
                      >
                        <option value={""}>--select--</option>
                        {bankList.map((item, id) => (
                          <option key={id} value={item.title}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.contractor_bank_name && (
                        <div className="invalid-feedback d-block">
                          {errors.contractor_bank_name}
                        </div>
                      )}
                    </>
                  ),
                },
                {
                  label: "Account Number",
                  name: "contractor_acc_no",
                  value: form.contractor_acc_no,
                  required: true,
                  error: errors.contractor_acc_no,
                },
                {
                  label: "Sort code",
                  value: form.sort_code,
                  name: "sort_code",
                },
              ]}
            />
          </Col>
        </Row>
  );
};
